import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
/**
 * Tag.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class Tag extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][Tag] organizationId is mandatory');
        }
        return `/ticket/organizations/${organizationId}/tags`;
    }
}
